module.exports = __webpack_public_path__ + "img/HT-M02.690157c8.jpg";